// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconSaveWant = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 25 24', fill: 'none', ...props },
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.846 18.947L20.688 24V1.6c0-.884-.72-1.6-1.608-1.6H4.611c-.888 0-1.607.716-1.607 1.6V24l8.842-5.053zm-7.342 2.468l6.597-3.77a1.5 1.5 0 011.489 0l6.598 3.77V1.6c0-.049-.042-.1-.108-.1H4.611a.104.104 0 00-.107.1v19.815z"
      fill="currentColor"
    />
  );
export default SvgIconSaveWant;
